import {
    DELETEBANKMAPPINGFORPARTNER_SUCCESS,
    DELETEBANKMAPPINGFORPARTNER_FAILED,
    RESET_DELETEBANKMAPPINGFORPARTNER,
    LOADING_DELETEBANKMAPPINGFORPARTNER,
    NETWORK_ERROR_DELETEBANKMAPPINGFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetDeleteBankMappingForPartner = () => {
    return { type: RESET_DELETEBANKMAPPINGFORPARTNER };
};

const partnerDeleteBankMapping = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETEBANKMAPPINGFORPARTNER });
    await partnerServices
        .post("deleteBankMappingForPartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerDeleteBankMappingsuccess(res.data));
                    break;
                default:
                    dispatch(partnerDeleteBankMappingFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DELETEBANKMAPPINGFORPARTNER,
                payload: err
            });
        });
};

function partnerDeleteBankMappingsuccess(data) {
    return {
        type: DELETEBANKMAPPINGFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerDeleteBankMappingFailed(data) {
    return {
        type: DELETEBANKMAPPINGFORPARTNER_FAILED,
        payload: data,
    };
}

export { resetDeleteBankMappingForPartner, partnerDeleteBankMapping }